import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/build/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceContent"] */ "/build/src/components/pages/resources/resource-content/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceFilters"] */ "/build/src/components/pages/resources/resource-filters/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchBar"] */ "/build/src/components/pages/resources/search-bar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/reusables/topic-tag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AspectRatio"] */ "/build/src/components/ui/aspect-ratio.tsx");
